import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant, caracteristicasResponseType } from "../types";

export const getCaracteristicas = (tenant: ITenant) =>
  axiosInstanceMain.get(`${tenant.path}/locales/caracteristicas?filtro=vendedor-configura-perfil`).then((result) => {
    return result?.data as caracteristicasResponseType;
  });
